module.exports = __webpack_public_path__ + "img/Z71_08.c603a7af.jpg";